import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'components/Icon';
import Style from 'screens/ContentDetail/components/Overlay/Overlay.module.scss';
import Overlay from 'screens/ContentDetail/components/Overlay';
import CastDetail from '../CastDetail';

const CastOverlay = ({ breakpoint, castInfo, castDetail, setCastDetail, disableScroll }) => {
  if (!castDetail) return null;

  const castArray = castInfo[castDetail.info.category];
  const { info, index } = castDetail;
  const renderArrows = castArray.length !== 1;
  const nextCast = index === castArray.length - 1 ? 0 : index + 1;
  const prevCast = index === 0 ? castArray.length - 1 : index - 1;

  const nextArrow = renderArrows ? (
    <button
      className={Style.nextCastArrow}
      onClick={() => {
        setCastDetail({ info: castArray[nextCast], index: nextCast });
      }}
    >
      <Icon color="white" size="medium" viewBox="0 0 25 42" icon="ios-arrow-right" />
    </button>
  ) : null;

  const prevArrow = renderArrows ? (
    <button
      className={Style.prevCastArrow}
      onClick={() => {
        setCastDetail({ info: castArray[prevCast], index: prevCast });
      }}
    >
      <Icon color="white" size="medium" viewBox="0 0 25 42" icon="ios-arrow-left" />
    </button>
  ) : null;

  return (
    <Overlay
      onClick={() => {
        setCastDetail(null);
        disableScroll({ disableScroll: false });
      }}
    >
      <div
        className={Style.inner}
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <button
          className={Style.close}
          type="button"
          onClick={() => {
            setCastDetail(null);
            disableScroll({ disableScroll: false });
          }}
        />
        <CastDetail
          breakpoint={breakpoint}
          detail={info}
          nextArrow={nextArrow}
          prevArrow={prevArrow}
          isModal
        />
      </div>
    </Overlay>
  );
};

CastOverlay.propTypes = {
  breakpoint: PropTypes.string,
  castInfo: PropTypes.arrayOf(PropTypes.shape({})),
  castDetail: PropTypes.shape({}),
  setCastDetail: PropTypes.func,
  disableScroll: PropTypes.func,
};

export default CastOverlay;
